// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1gfRS","overlay":"style__overlay___1Y4hu","selectedItemText":"style__selectedItemText___Se9S8","itemText":"style__itemText___2wxVl"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-forms/components/select/style.css
// module id = 1062
// module chunks = 0